module.exports = __webpack_public_path__ + "static/media/trash_can.7197d26e.svg";